// 输入框组件翻译
export default {
  // 占位符文本
  placeholders: {
    email: "请输入邮箱地址",
    password: "请输入密码",
    phone: "请输入手机号码",
    name: "请输入姓名",
    username: "请输入用户名",
    search: "请输入搜索关键词",
    title: "请输入标题",
    content: "请输入内容",
    description: "请输入描述",
    remark: "请输入备注",
    url: "请输入网址",
    amount: "请输入金额",
    quantity: "请输入数量",
    date: "请选择日期",
    time: "请选择时间",
  },

  // 验证消息
  validation: {
    required: "此字段为必填项",
    emailFormat: "请输入正确的邮箱格式",
    phoneFormat: "请输入正确的手机号格式",
    urlFormat: "请输入正确的网址格式",
    numberFormat: "请输入有效的数字",
    minLength: "最少输入 {min} 个字符",
    maxLength: "最多输入 {max} 个字符",
    minValue: "最小值为 {min}",
    maxValue: "最大值为 {max}",
    pattern: "格式不正确",
    unique: "此值已存在",
    confirm: "两次输入不一致",
  },

  // 操作提示
  clear: "清空",
  show: "显示",
  hide: "隐藏",
  copy: "复制",
  paste: "粘贴",
  select: "选择",
  browse: "浏览",

  // 状态文本
  readonly: "只读",
  disabled: "已禁用",
  optional: "可选",
  required: "必填",

  // 文件上传
  upload: {
    selectFile: "选择文件",
    dragDrop: "拖拽文件到此处或",
    fileSize: "文件大小不能超过 {size}",
    fileType: "支持的文件类型：{types}",
    uploadSuccess: "上传成功",
    uploadFailed: "上传失败",
    uploading: "上传中...",
  },
};
